// extracted by mini-css-extract-plugin
export default {"container":"UserForm_container__7O6yT","body":"UserForm_body__f18YQ","startAdornment":"UserForm_startAdornment__LWy-T"};